import { TAB_QUERY_KEY } from '@/app/(main)/client-detail/consts/client-detail';
import { CLIENT_ID_QUERY_KEY } from '@/consts/const';
import { CLIENT_DETAIL_INTERNAL_PATH } from '@/consts/paths';

export function buildClientDetailHref(
  clientId: number,
  options?: { tab?: string; }
) {
  const params = new URLSearchParams();
  params.set(CLIENT_ID_QUERY_KEY, String(clientId));
  params.set(TAB_QUERY_KEY, options?.tab ?? 'main');
  return `${CLIENT_DETAIL_INTERNAL_PATH}?${params.toString()}`;
}
